import React from 'react'
import homeImg from '../assets/writeimg.svg'
import Card from '../components/Card';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar'
export default function Write() {
    return (
        <div className='bg-write-bg min-h-screen h-auto w-full flex flex-col justify-between'>
            <div>
            <Navbar bgrenk="bg-write-bg" renk="text-write-pr" renk2="text-write-li"></Navbar>
            <div className='flex justify-center mx-[16px] md:mx-[150px] items-center mt-[50px] gap-x-5'>
                <div className='gap-y-5 flex flex-col'> 
                    <h1 className='text-6xl flex leading-[75px] font-semibold text-write-pr'>Yazılarım.</h1>
                    <Card renk="text-write-pr" renk2="text-write-sc" renk3="bg-write-card-bg" date="2023 Oct" title="Next.js ile Notion Üzerinden Blog Yazılarını Çekme Rehberi" ahref="https://caglaunsall.medium.com/next-js-ile-notion-%C3%BCzerinden-blog-yaz%C4%B1lar%C4%B1n%C4%B1-%C3%A7ekme-rehberi-76ba53960e85" a="Devamını oku"></Card>
                    <Card renk="text-write-pr" renk2="text-write-sc" renk3="bg-write-card-bg" date="2022 Sep" title="Uygulamalı Metasploitable 2 Sızma Testleri" ahref="https://caglaunsall.medium.com/uygulamal%C4%B1-metasploitable-2-s%C4%B1zma-testleri-43b89c9acad3" a="Devamını oku"></Card>
                    <Card renk="text-write-pr" renk2="text-write-sc" renk3="bg-write-card-bg" date="2021 Aug" title="Sass Nedir Ne İşe Yarar?" ahref="https://caglaunsall.medium.com/sass-nedir-ne-i%CC%87%C5%9Fe-yarar-760b44474446" a="Devamını oku"></Card>
                    <Card renk="text-write-pr" renk2="text-write-sc" renk3="bg-write-card-bg"date="2021 Jun" title="Yeni Başlayanlar İçin HTML ve CSS" ahref="https://caglaunsall.medium.com/html-ve-css-5de473b67919" a="Devamını oku"></Card>
                </div>
                <div className='hidden lg:flex'>
                    <img className='w-[437px]' src={homeImg} alt="" />
                </div> </div>
                </div>
            <Footer renk2="text-write-li"></Footer>
        </div>
    )
}
